import React from 'react';

export type Vendor = {
  name: string;
  email: string;
  callGroup: string;
  rescueMenus: string[];
};

export type VendorSectionProps = {
  vendors: Vendor[];
  setVendors: React.Dispatch<React.SetStateAction<Vendor[]>>;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  CALL_GROUPS: { value: string; label: string }[];
  RESCUE_MENUS: { value: string; label: string }[];
};

const VendorSection: React.FC<VendorSectionProps> = ({
  vendors,
  setVendors,
  open,
  setOpen,
  CALL_GROUPS,
  RESCUE_MENUS,
}) => {
  const handleVendorChange = (idx: number, e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    if (name === 'rescueMenus') {
      const checked = (e.target as HTMLInputElement).checked;
      setVendors((prev) => prev.map((v, i) => {
        if (i !== idx) return v;
        if (checked) {
          return { ...v, rescueMenus: [...v.rescueMenus, value] };
        } else {
          return { ...v, rescueMenus: v.rescueMenus.filter((m) => m !== value) };
        }
      }));
    } else {
      setVendors((prev) => prev.map((v, i) => i === idx ? { ...v, [name]: value } : v));
    }
  };
  const addVendor = () => {
    setVendors((prev) => [
      ...prev,
      { name: '', email: '', callGroup: '', rescueMenus: [] },
    ]);
  };
  const removeVendor = (idx: number) => {
    setVendors((prev) => prev.filter((_, i) => i !== idx));
  };

  return (
    <div>
      <button type="button" className={`flex items-center justify-between w-full pt-1 pb-2 text-left text-lg font-bold text-gray-800 border-b border-gray-200 focus:outline-none`} onClick={() => setOpen((v) => !v)}>
        <span>既存お取引業者登録</span>
        <span className="text-base">{open ? '▲' : '▼'}</span>
      </button>
      {open && (
        <div className="p-4 text-sm text-gray-600 bg-white border border-gray-200 rounded-b-lg shadow-md">
          <div className="flex flex-col gap-6">
            {vendors.map((v, idx) => (
              <div key={idx} className="relative p-4 border border-gray-100 rounded-lg bg-gray-50">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <label className="block mb-1 text-sm font-semibold text-gray-500">業者名</label>
                    <input type="text" name="name" className="w-full px-2 py-1 border border-gray-200 rounded" value={v.name} onChange={e => handleVendorChange(idx, e)} />
                  </div>
                  <div>
                    <label className="block mb-1 text-sm font-semibold text-gray-500">メールアドレス</label>
                    <input type="email" name="email" className="w-full px-2 py-1 border border-gray-200 rounded" value={v.email} onChange={e => handleVendorChange(idx, e)} />
                  </div>
                  <div>
                    <label className="block mb-1 text-sm font-semibold text-gray-500">コールグループ</label>
                    <select name="callGroup" className="w-full px-2 py-1 text-sm font-semibold text-gray-500 border border-gray-200 rounded" value={v.callGroup} onChange={e => handleVendorChange(idx, e)}>
                      <option value="">選択してください</option>
                      {CALL_GROUPS.map(g => <option key={g.value} value={g.value}>{g.label}</option>)}
                    </select>
                  </div>
                  <div>
                    <label className="block mb-1 text-sm font-semibold text-gray-500">レスキューメニュー</label>
                    <div className="flex flex-wrap gap-2 mt-1">
                      {RESCUE_MENUS.map(m => (
                        <label key={m.value} className="flex items-center gap-1 text-sm font-semibold text-gray-500">
                          <input
                            type="checkbox"
                            name="rescueMenus"
                            value={m.value}
                            checked={v.rescueMenus.includes(m.value)}
                            onChange={e => handleVendorChange(idx, e)}
                          />
                          <span>{m.label}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
                <button type="button" className="absolute text-xs text-red-500 underline top-2 right-2" onClick={() => removeVendor(idx)} disabled={vendors.length === 1}>削除</button>
              </div>
            ))}
            <button type="button" className="px-4 py-1 text-xs font-semibold text-blue-700 bg-blue-100 rounded hover:bg-blue-200" onClick={addVendor}>＋ 業者情報を追加</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default VendorSection;
